import $ from 'jquery'
import {orgText} from '../cads/cache/get'

const getAtsRep = (orgId, callback) => {
  let randomNum = Math.floor(Math.random()*99999999).toString()
  let url = 'https://' + process.env.REACT_APP_S3_BUCKET_NAME + '.s3.amazonaws.com/stock_report/ats_rep/ats_rep' + orgText(orgId) + '.json?t=' + randomNum

  $.get(url, function (result) {
    callback(JSON.parse(result))
  })
}

export {getAtsRep}
